import type React from "react";
import { useTranslation } from "../hooks/useTranslation";
import appStyles from "../styles/styles";
import type { RecordingFile } from "../types/models";

interface RecordingHistoryHeaderProps {
	totalRecordings: number;
	filteredRecordings: Array<RecordingFile>;
	selectedRecordings: Set<string>;
	selectedWithTranscriptionCount: number;
	toggleSelectAll: () => void;
	downloadSelectedRecordings: () => void;
	downloadSelectedTranscriptions: () => void;
	deleteSelectedRecordings: () => void;
	clearRecordings: () => void;
}

export const RecordingHistoryHeader: React.FC<RecordingHistoryHeaderProps> = ({
	totalRecordings,
	filteredRecordings,
	selectedRecordings,
	selectedWithTranscriptionCount,
	toggleSelectAll,
	downloadSelectedRecordings,
	downloadSelectedTranscriptions,
	deleteSelectedRecordings,
	clearRecordings,
}) => {
	const t = useTranslation();
	return (
		<div className={`${appStyles.recordingHistoryHeader} border-b border-gray-300/40 dark:border-gray-700/40 pb-3`}>
			<div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
				{totalRecordings > 0 && (
					<div className="flex flex-wrap gap-2 justify-end">
						<button
							type="button"
							onClick={toggleSelectAll}
							className={`${appStyles.actionButtonSecondary} py-1.5 px-4`}
						>
							{selectedRecordings.size === filteredRecordings.length ? t.deselectAll : t.selectAll}
						</button>
						{selectedRecordings.size > 0 ? (
							<>
								<button
									type="button"
									onClick={downloadSelectedRecordings}
									className={`${appStyles.actionButtonSecondary} py-1.5 px-4`}
									title={t.downloadSelectedRecordingsTitle}
								>
									<span className="mr-2">🔊</span> {t.audioDownload} ({selectedRecordings.size})
								</button>

								{selectedWithTranscriptionCount > 0 && (
									<button
										type="button"
										onClick={downloadSelectedTranscriptions}
										className={`${appStyles.actionButtonSecondary} py-1.5 px-4`}
										title={t.downloadSelectedTranscriptionsTitle}
									>
										<span className="mr-2">📝</span> {t.transcriptionDownload} ({selectedWithTranscriptionCount})
									</button>
								)}
								<button
									type="button"
									onClick={deleteSelectedRecordings}
									className={`${appStyles.actionButtonSecondary} py-1.5 px-4`}
								>
									{t.deleteSelected}
								</button>
							</>
						) : (
							<button
								type="button"
								onClick={() => {
									if (confirm(t.clearHistoryConfirmation)) {
										clearRecordings();
									}
								}}
								className={`${appStyles.actionButtonSecondary} py-1.5 px-4`}
							>
								{t.clearHistory}
							</button>
						)}
					</div>
				)}
			</div>
		</div>
	);
};

export default RecordingHistoryHeader;
